import { combineReducers } from 'redux';
import reducerReducers from 'reduce-reducers';
import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';
import changeValueReducerFactory from '@nhl/change-value-reducer-factory';

import { clearErrorsOnActionTypeReducerFactory } from '../../utils';
import actionTypes from './actionTypes';

/* State shape
    saveState: {
        isLoading: bool,
        success: bool,
        errors: Array
    },
    passwordState: {
        currentPassword: String,
        newPassword: String,
        confirmPassword: String
    }
*/

const saveStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_SAVE)(actionTypes.SAVE_RESPONSE);
const enhancedSaveStateReducer = reducerReducers(saveStateReducer,
    clearErrorsOnActionTypeReducerFactory(actionTypes.CHANGE_VALUE));

const currentPasswordReducer = changeValueReducerFactory('')(actionTypes.CHANGE_VALUE, 'currentPassword',
    actionTypes.SAVE_RESPONSE, 'password');
const newPasswordReducer = changeValueReducerFactory('')(actionTypes.CHANGE_VALUE, 'newPassword',
    actionTypes.SAVE_RESPONSE, 'password');
const confirmPasswordReducer = changeValueReducerFactory('')(actionTypes.CHANGE_VALUE, 'confirmPassword',
    actionTypes.SAVE_RESPONSE, 'password');

const passwordReducer = combineReducers({
    currentPassword: currentPasswordReducer,
    newPassword: newPasswordReducer,
    confirmPassword: confirmPasswordReducer
});

const reducer = combineReducers({
    saveState: enhancedSaveStateReducer,
    passwordState: passwordReducer
});

export default reducer;